import { render } from "./ProdPrice.vue?vue&type=template&id=18fd57ce&scoped=true"
import script from "./ProdPrice.vue?vue&type=script&lang=js"
export * from "./ProdPrice.vue?vue&type=script&lang=js"

import "./ProdPrice.vue?vue&type=style&index=0&id=18fd57ce&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18fd57ce"]])

export default __exports__